import { ApiResponse } from '@/types/api';
import { Collection as CollectionType } from '@/types/collection';
import Base from './Base';

class Collection extends Base {
  async getCollectionByShareToken(token: string) {
    const response = await this.apiClient.get<ApiResponse<CollectionType, void>>(
      `/share/public/collections/${token}`,
    );

    return response.data;
  }
}

export default Collection;
